export function isDayjs(obj?: any) {
  return obj?.$isDayjsObject !== undefined
}

export function isMoment(obj?: any) {
  return obj?._isAMomentObject !== undefined
}

export function isValidDate(obj?: any) {
  return obj instanceof Date && !isNaN(obj)
}
